import script from "./RecaptchaField.vue?vue&type=script&setup=true&lang=js"
export * from "./RecaptchaField.vue?vue&type=script&setup=true&lang=js"

import "./RecaptchaField.vue?vue&type=style&index=0&id=318ee386&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318ee386"]])

export default __exports__